function calendarLocale(locale: string) {
  return locale.startsWith('ar') ? 'ar-SA-u-ca-gregory' : 'en-US'
}

export function formatGuestDateTime(iso: string | null | undefined, locale: string) {
  if (!iso?.trim()) return ''

  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return iso

  return date.toLocaleString(calendarLocale(locale), {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    calendar: 'gregory',
  })
}

export function formatAgendaDayDate(isoDate: string | null | undefined, locale: string) {
  if (!isoDate?.trim()) return ''

  const match = isoDate.trim().match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (!match) return isoDate

  const year = Number(match[1])
  const month = Number(match[2])
  const day = Number(match[3])
  const date = new Date(year, month - 1, day)

  if (Number.isNaN(date.getTime())) return isoDate

  // ar-SA defaults to the Islamic (Umm al-Qura) calendar in CLDR. Safari on
  // iOS follows that, so Arabic event dates would otherwise appear as Hijri.
  return date.toLocaleDateString(calendarLocale(locale), {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    calendar: 'gregory',
  })
}
